(() => {
  let context;
  let master;
  let running = false;
  let suspendTimer;
  const buttons = () => Array.from(document.querySelectorAll('[data-hg-sound]'));

  function update() {
    buttons().forEach(button => {
      button.setAttribute('aria-pressed', String(running));
      const label = button.querySelector('[data-hg-sound-label]');
      if (label) label.textContent = running ? button.dataset.soundOn : button.dataset.soundOff;
    });
  }

  function breathe(audio, parameter, frequency, depth) {
    const oscillator = audio.createOscillator();
    const amount = audio.createGain();
    oscillator.frequency.value = frequency;
    amount.gain.value = depth;
    oscillator.connect(amount);
    amount.connect(parameter);
    oscillator.start();
  }

  function makeContext() {
    const Audio = window.AudioContext || window.webkitAudioContext;
    if (!Audio) return false;
    const audio = new Audio();
    context = audio;
    master = audio.createGain();
    master.gain.value = 0;
    const highpass = audio.createBiquadFilter();
    highpass.type = 'highpass';
    highpass.frequency.value = 45;
    const lowpass = audio.createBiquadFilter();
    lowpass.type = 'lowpass';
    lowpass.frequency.value = 900;
    lowpass.Q.value = 0.3;
    highpass.connect(lowpass);
    lowpass.connect(master);
    master.connect(audio.destination);

    [
      [65.4075, 0.045, 0.019, 0.01],
      [97.999, 0.035, 0.027, 0.008],
      [130.815, 0.028, 0.013, 0.006]
    ].forEach(([frequency, level, rate, depth], index) => {
      const oscillator = audio.createOscillator();
      const gain = audio.createGain();
      oscillator.type = 'sine';
      oscillator.frequency.value = frequency;
      oscillator.detune.value = index === 1 ? 2 : -1;
      gain.gain.value = level;
      oscillator.connect(gain);
      gain.connect(highpass);
      breathe(audio, gain.gain, rate, depth);
      oscillator.start();
    });

    const buffer = audio.createBuffer(1, audio.sampleRate * 12, audio.sampleRate);
    const samples = buffer.getChannelData(0);
    let pink0 = 0;
    let pink1 = 0;
    let pink2 = 0;
    for (let index = 0; index < samples.length; index++) {
      const white = Math.random() * 2 - 1;
      pink0 = 0.99765 * pink0 + white * 0.099046;
      pink1 = 0.963 * pink1 + white * 0.2965164;
      pink2 = 0.57 * pink2 + white * 1.0526913;
      samples[index] = (pink0 + pink1 + pink2 + white * 0.1848) * 0.08;
    }
    const air = audio.createBufferSource();
    const airHighpass = audio.createBiquadFilter();
    const airLowpass = audio.createBiquadFilter();
    const airGain = audio.createGain();
    air.buffer = buffer;
    air.loop = true;
    airHighpass.type = 'highpass';
    airHighpass.frequency.value = 150;
    airLowpass.type = 'lowpass';
    airLowpass.frequency.value = 1100;
    airLowpass.Q.value = 0.4;
    airGain.gain.value = 0.16;
    air.connect(airHighpass);
    airHighpass.connect(airLowpass);
    airLowpass.connect(airGain);
    airGain.connect(highpass);
    breathe(audio, airGain.gain, 0.036, 0.06);
    breathe(audio, airLowpass.frequency, 0.022, 280);
    air.start();

    audio.addEventListener('statechange', () => {
      if (context !== audio) return;
      if (audio.state !== 'running' && running) {
        running = false;
        master.gain.cancelScheduledValues(audio.currentTime);
        master.gain.setValueAtTime(0, audio.currentTime);
        update();
      }
    });
    return true;
  }

  function stop() {
    running = false;
    clearTimeout(suspendTimer);
    if (context && master && context.state !== 'closed') {
      const audio = context;
      master.gain.cancelScheduledValues(audio.currentTime);
      master.gain.setTargetAtTime(0, audio.currentTime, 0.4);
      suspendTimer = setTimeout(() => {
        if (!running && context === audio) audio.suspend().catch(() => {});
      }, 1800);
    }
    update();
  }

  async function toggle(button) {
    if (button.disabled) return;
    button.disabled = true;
    try {
      if (running) {
        stop();
        return;
      }
      if ((!context || context.state === 'closed') && !makeContext()) return;
      clearTimeout(suspendTimer);
      await context.resume();
      if (context.state !== 'running' || document.hidden) return;
      running = true;
      master.gain.cancelScheduledValues(context.currentTime);
      master.gain.setTargetAtTime(0.22, context.currentTime, 1.4);
      update();
    } catch {
      stop();
    } finally {
      button.disabled = false;
    }
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-hg-sound]');
    if (button) toggle(button);
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && running) stop();
  });
  window.addEventListener('pagehide', () => {
    clearTimeout(suspendTimer);
    running = false;
    if (context && context.state !== 'closed') context.close().catch(() => {});
    context = undefined;
    master = undefined;
    update();
  });
})();
